import Gtm from '@grebban/gtm';

type SizeSelection = {
    id: string;
    name: string;
    size: string;
    sku: string;
};

export default (sizeSelection: SizeSelection) => {
    Gtm.addDataLayerEvent('select_size', {
        optimizely: {
            id: sizeSelection.id,
            name: sizeSelection.name,
            size: sizeSelection.size,
            sku: sizeSelection.sku,
        },
    });
};
